import { Stack, Typography } from '@mui/material';
import { RadioInput } from 'Components/HookFormInputs/RadioInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { IDoctorsSuppliers } from 'Interfaces/doctorsSuppliers';
import { useFormContext } from 'react-hook-form';

const IsAccessible = () => {
  const { watch, setValue } = useFormContext<IDoctorsSuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).doctorsSearchForm;

  return (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
      component='fieldset'
    >
      <legend>{dictionary.isAccessible}</legend>
      <Typography variant='body2'>{dictionary.isAccessible}</Typography>
      <RadioInput
        options={[
          { value: true, label: dictionary.accessibleClinic },
          { value: false, label: dictionary.homeTreatment },
        ]}
        name={'accessible'}
        externalValue={watch('accessible') || ''}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          switch (event.target.value) {
            case '1':
              if (watch('homeVisit') !== null) setValue('homeVisit', null);
              setTimeout(() => {
                setValue('accessible', true);
              }, 0);

              break;

            case '2':
              if (watch('homeVisit') !== null) setValue('homeVisit', null);
              setTimeout(() => {
                setValue('accessible', false);
              }, 0);
              break;

            case '3':
              setValue('homeVisit', true);
              setTimeout(() => {
                if (watch('accessible') !== null) setValue('accessible', null);
              }, 0);
              break;
          }
        }}
        replaceInternalOnChange={true}
      />
    </Stack>
  );
};

export default IsAccessible;
